import { Button } from '@nespresso-design-system/components';
import useTranslations from '@/widgets/hooks/useTranslations';
import type { Translations } from '@/widgets/ProductList/config';
import type { FiltersAndSort } from '@/widgets/services/FilteringAndSortingService';

type ProductResultsProps = {
  products: FiltersAndSort['products'];
  onClick: () => void;
};

export default function ProductResultsButton({
  products,
  onClick
}: ProductResultsProps) {
  const { t } = useTranslations<Translations>();
  const seeResultsLabel = t('productList.filtersDrawer.seeResults', {
    count: products.value.length
  });

  return (
    <Button
      label={seeResultsLabel}
      variant="secondary"
      onClick={onClick}
      aria-label={seeResultsLabel}
    >
      {seeResultsLabel}
    </Button>
  );
}
